/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestDto } from '../../models/test-dto';

export interface GetnotificationsTestUpdatedSchema$Params {
}

export function getnotificationsTestUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsTestUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsTestUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestDto>;
    })
  );
}

getnotificationsTestUpdatedSchema.PATH = '/api/hubs/notifications/TestUpdated';
